// constants
export const STATUS_ORIGINAL = 0; // The default status, locating at the original position.
export const STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.
export const STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.
